import { CommentCreatePage } from './pages/create/create.page';
import { CommentEditPage } from './pages/edit/edit.page';
import { CommentIndexPage } from './pages/index/index.page';

export { CommentCreatePage } from './pages/create/create.page';
export { CommentEditPage } from './pages/edit/edit.page';
export { CommentIndexPage } from './pages/index/index.page';

export const Pages = [
    CommentCreatePage,
    CommentEditPage,
    CommentIndexPage
];



// WEBPACK FOOTER //
// ./libs/chassis-comments/src/app/pages.ts